module.exports = __webpack_public_path__ + "static/engagingNews-c95c6d47deb5dff7663fb8f746fa4a16.gif";